import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLB = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0C15.09 0 6.525 5.768 2.48 14.13h45.04C43.475 5.768 34.911 0 25 0ZM25 50c9.912 0 18.476-5.768 22.52-14.13H2.48C6.526 44.232 15.09 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M31.522 29.348 25 17.392 18.48 29.348h4.891v3.26h3.26v-3.26h4.892Z"
}));
FlagLB.displayName = 'FlagLB';
export default withFlagWrapper(FlagLB);
//# sourceMappingURL=index.js.map